import { useCallback, useMemo, useState } from 'react';

import { ExtranetPendingChange } from '~/services/ExtranetService';

export default function useExtranetApprovalsSelection(selectableRows: Array<ExtranetPendingChange>) {
  const [selected, setSelected] = useState<Set<string>>(new Set());

  const clearSelection = useCallback(() => {
    setSelected(new Set());
  }, []);

  const toggleSelect = useCallback((id: string) => {
    setSelected((prev) => {
      const next = new Set(prev);
      if (next.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }
      return next;
    });
  }, []);

  const toggleSelectAll = useCallback(() => {
    setSelected((prev) => {
      if (prev.size === selectableRows.length) {
        return new Set();
      }
      return new Set(selectableRows.map((row) => row.id));
    });
  }, [selectableRows]);

  const selectedIds = useMemo(() => Array.from(selected), [selected]);
  const allSelected = selectableRows.length > 0 && selected.size === selectableRows.length;

  return {
    allSelected,
    clearSelection,
    selected,
    selectedIds,
    toggleSelect,
    toggleSelectAll,
  };
}
